import gql from 'graphql-tag';

export const updateDashboard = gql`
  mutation UpdateDashboardMutation($input: UpdateDashboard!) {
    updateDashboard(input: $input) {
      id
    }
  }
`;

export const createDashboard = gql`
  mutation CreateDashboardMutation($input: CreateDashboard!) {
    createDashboard(input: $input) {
      id
    }
  }
`;

export const createUserEntityWidgetAssociation = gql`
  mutation CreateUserEntityWidgetAssociationMutation($input: CreateUserEntityWidgetAssociation!) {
    createUserEntityWidgetAssociation(input: $input) {
      entityWidgetId
    }
  }
`;

export const deleteUserEntityWidgetAssociation = gql`
  mutation DeleteUserEntityWidgetAssociationMutation($input: DeleteUserEntityWidgetAssociation!) {
    deleteUserEntityWidgetAssociation(input: $input)
  }
`;
